export default __webpack_public_path__ + "static/seal-c78c336717a9613774d255aa6c00a8c4.png";